import { readContent } from './read'
import { updateContent } from './update'

export const content = {
  readSingle: readContent,
  update: updateContent,
}
